export default "__VITE_ASSET__MvwjkOEf__"